import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { formatUtcDateTime } from '@/utils/date';
import type { LicenseStatus } from '@/types/license';
import { CopyableValueRow } from './CopyableValueRow';
import { DetailRow } from './DetailRow';
import { HealthBadge } from './HealthBadge';

export function AwsConnectivityRows({ license }: { license: LicenseStatus }) {
    const { t } = useTranslation(I18nNamespace.SETTINGS);
    const clockNowEpochSec = license.clockHealthy
        ? license.clockNowEpochSec
        : null;

    return (
        <>
            <CopyableValueRow
                label={t('license.awsAccount')}
                value={license.currentAccountId}
                displayValue={(accountId) => accountId}
                unavailable={<HealthBadge healthy={false} />}
                status={<HealthBadge healthy={license.imdsHealthy === true} />}
            />
            <DetailRow label={t('license.clock')}>
                {clockNowEpochSec !== null ? (
                    <div className="flex items-center gap-2 justify-end">
                        <span className="text-xs text-grey-100">
                            {`${formatUtcDateTime(clockNowEpochSec)} ${
                                license.clockTimezone ?? 'UTC'
                            }`}
                        </span>
                        <HealthBadge healthy />
                    </div>
                ) : (
                    <HealthBadge healthy={false} />
                )}
            </DetailRow>
        </>
    );
}
